<div class="message-wrapper">
  <span class="message">
    <ng-content></ng-content>
  </span>
</div>
